import gql from "graphql-tag";
import get from "lodash/get";

export const ITEMS_PER_PAGE = 20;

export const unreadCountQueryOptions = {
    name: "data",
    skip: (props) => !props.me,
    options() {
        return {
            fetchPolicy: "cache-and-network",
        };
    },
    props({data: {unreadCount}}) {
        return {
            unreadCount: get(unreadCount, "count", 0),
        };
    },
};

export const unreadCountQuery = gql`
    query unreadCount {
        unreadCount {
            count
        }
    }
`;
